<template>
  <v-row
    no-gutters
    align="center"
    justify="center"
    justify-lg="space-between"
    class="lg:flex-nowrap"
  >
    <v-col
      cols="24"
      lg="auto"
      class="max-lg:mb-8"
    >
      <u-text
        class="max-lg:text-center text-caption"
        :color="color"
        text="As featured in"
      />
    </v-col>
    <template
      v-for="(partner, index) in partners"
      :key="index"
    >
      <v-col
        cols="12"
        lg="auto"
        class="px-3"
      >
        <partner-logo
          :logo="partner"
          :fill="color"
          class="max-lg:mx-auto"
        />
      </v-col>
      <v-spacer
        v-if="index === 1"
        class="w-full my-4 lg:hidden"
      />
    </template>
  </v-row>
</template>

<script setup lang="ts">
type Partners = 'BBC' | 'MoneySavingExpert' | 'GovUk' | 'FinancialTimes'

const {
  partners = ['BBC', 'MoneySavingExpert', 'GovUk', 'FinancialTimes'],
} = defineProps<{
  color?: string
  partners?: Partners[]
}>()
</script>
